export default "__VITE_ASSET__DTz71Ak$__"